import Vue from 'vue'
import moment from 'moment'
import ja from 'vee-validate/dist/locale/ja.json'
import { ValidationProvider, ValidationObserver, localize, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import { isOverlap, validProposals } from '@/entities/Appointment'
import { resolveDoctorRule } from '@/entities/Doctor'
import { validateAuthEmail } from '@/utils/emailInput'
import { isTimeWithinRegisteredRanges } from '@/utils/appointmentTime'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Object.keys(rules).forEach((key) => {
  const value: any = rules
  extend(key, value[key])
})

localize('ja', ja)

extend('password_strict', {
  validate(value: string) {
    return /^(?=.*?[a-zA-Z])(?=.*?[0-9])[a-zA-Z0-9\-_#$%&!]{8,255}$/.test(value)
  },
  message: 'パスワードは8〜255文字で、英字と数字を各1文字以上含む必要があります（使用可能記号: -_#$%&!）'
})

extend('email_address_input', {
  validate(value: string) {
    const message = validateAuthEmail(value)
    return message === null ? true : message
  }
})

extend('phone', {
  validate(value) {
    const regs = [
      /^0\d-\d{4}-\d{4}$/,
      /^0\d{2}-\d{3}-\d{4}$/,
      /^0\d{3}-\d{2}-\d{4}$/,
      /^0\d{4}-\d-\d{4}$/,
      /^050-\d{4}-\d{4}$/,
      /^0120-\d{3}-\d{3}$/,
      /^(070|080|090)-\d{4}-\d{4}$/,
      /^(0570)-\d{3}-\d{3}$/
    ]
    return !!regs.find((reg) => reg.test(value))
  },
  message: '{_field_}は正しい形式ではありません'
})

extend('mobile', {
  validate(value) {
    return /^(070|080|090)-\d{4}-\d{4}$/.test(value)
  },
  message: '{_field_}は正しい形式ではありません'
})

extend('zip', {
  validate(value) {
    return /^[0-9]{3}-[0-9]{4}$/.test(value)
  },
  message: '{_field_}は正しい形式ではありません'
})

extend('total_size', {
  params: ['limit'],
  validate(value: File[], args: any) {
    const total = value.reduce((sum, file) => sum + file.size, 0)
    console.log('total', total)
    return total <= args.limit * 1000 * 1000
  },
  message: '合計ファイルサイズは {limit} MB以下である必要があります'
})

extend('doctor', {
  params: ['doctor'],
  validate(value: { started: string | null; ended: string | null }, args: any) {
    if (args.doctor) {
      moment.locale('ja')
      const started = moment(value.started)
      const ended = moment(value.ended)
      // 日付を解釈できない候補は日付側の検証に任せ、ここでは可否を決めない
      if (!started.isValid()) return true
      const rule = resolveDoctorRule(args.doctor, started.format('YYYY-MM-DD'))

      if (rule?.value === 2) {
        args.message = 'この日時は予約できません。別の日時を選んでください。'
        return false
      }

      if (rule?.value === 3) {
        // 病院側で「時間指定」を選んだのに時刻が未入力のまま保存された曜日は、
        // 終日可と同じ8:00-20:00の制限で扱う
        if (!isTimeWithinRegisteredRanges(started.format('HH:mm'), ended.format('HH:mm'), rule.times)) {
          args.message = 'この時間は予約できません。別の時間を選んでください。'
          return false
        }
      }
    }

    return true
  },
  message: (_field, params) => {
    return params.message || 'この日時は予約できません。別の日時を選んでください。'
  }
})

// 候補日時のうち、日付が入力済みのものが1件以上あるかをチェックする
extend('proposals', {
  params: ['proposals'],
  validate(_value: any, args: any) {
    // 候補が1件のときは配列が展開されて要素だけが渡るため、配列に揃える
    const proposals = Array.isArray(args.proposals) ? args.proposals : args.proposals ? [args.proposals] : []
    return validProposals(proposals).length > 0
  },
  message: '候補日時を1件以上入力してください。'
})

// 医師のアポイントの情報を取得して、時間の重複をチェックする
extend('overlap', {
  params: ['appointment'],
  validate(value: { started: string | null; ended: string | null }, args: any) {
    moment.locale('ja')
    const started = moment(value.started)
    const ended = moment(value.ended)
    const date = started.format('YYYY-MM-DD')

    if ((args.appointment[date]?.length || 0) > 0) {
      const time = args.appointment[date].find((appointment: any) => isOverlap({ started, ended }, appointment))
      if (time) {
        args.message = 'この日時は予約できません。別の日時を選んでください。'
        return false
      }
    }
    return true
  },
  message: (_field, params) => {
    console.log('message', _field)
    return params.message || 'この日時は予約できません。別の日時を選んでください。'
  }
})
